
import React, { useState, useEffect } from 'react';

import { HiOutlineSearch } from "react-icons/hi";


import ControlOverlay from "./ControlOverlay";
import Popup from 'reactjs-popup';
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { escapeForRgex } from "@amcharts/amcharts4/.internal/core/utils/Utils";

const localizer = momentLocalizer(moment);
    


    
    const CalendarView = ({ events }) => {
    const [selectedControl, setSelectedControl] = useState(null);
    const transformedEvents = events.flatMap((control) => {
        const start = new Date(control.startDate || Date.now());
        const end = new Date(control.endDate || Date.now());

        // Helper: clone date and add N months
        const addMonths = (date, months) => {
            const d = new Date(date);
            d.setMonth(d.getMonth() + months);
            return d;
        };
        const addDays = (date, days) => {
            const d = new Date(date);
            d.setDate(d.getDate() + days);
            return d;
        };

        ////console.log("Not shown Control", control)
        if(control.secondLine === 0){
            //console.log("Not shown Control", control)
            return []
        }
        //const keys = Object.keys(control);
        ////console.log(keys)
        if (control.controlPeriod === "Monthly" || control.controlPeriod === "Quarterly" || control.controlPeriod === "Weekly") {
            const eventList = [];
            let current = new Date(start);
            //console.log("Monthly")
            const repeatEnd =  new Date();
            repeatEnd.setDate(end.getDate() + 365)
            let daysonRepeat = 0
            let end_c = new Date(end)
            while(current <= repeatEnd ){
                daysonRepeat = 0
                
                
                eventList.push({
                    title: control.controlDetails || "No Title",
                    start: new Date(current),
                    end: new Date(end_c), 
                    allDay: true,
                    controlID: control.controlID,
                    riskId: control.riskId
                });

                    
                if (control.controlPeriod === "Monthly") {
                    current = addMonths(current, 1);
                   end_c = addMonths(end_c, 1)
                }else if(control.controlPeriod === "Quarterly"){
                    current = addMonths(current, 3);
                    end_c = addMonths(end_c, 3)
                }else {
                    current = addDays(current, 7);
                    end_c = addDays(end_c, 7)
                }
            
        }

            return eventList;
        }
        
        
        // Default (single event)
        return [
            {
                title: control.controlDetails || "No Title",
                start: start,
                end: end,
                allDay: true,
                controlID: control.controlID,
                riskId: control.riskId
            }
        ];
    });

    const handleEventClick = (event) => {
        //console.log("Picked Contorl", event)
        setSelectedControl(event);
    };

    return (
        <div className="calendar-container" style={{ width: "80vw", height: "calc(80vh - 100px)" }}>
            <Calendar
                localizer={localizer}
                events={transformedEvents}
                onSelectEvent={handleEventClick}
                startAccessor="start"
                endAccessor="end"
                className="shadow-lg rounded-md"
                style={{ height: "100%", width: "100%" }}
            />

             {selectedControl && (
                   <Popup
                    open={true}
                    onClose={() => setSelectedControl(null)} 
                    contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '900px', marginTop: '14vh' }}>
                    <ControlOverlay key={selectedControl.controlID || 'new-control'} closeControl={() => setSelectedControl(null)} control_id={selectedControl.controlID} risk_id={selectedControl.riskId} />
                    </Popup>
                  )}
        </div>

        
    );
};

export default CalendarView;